import audio1 from 'assets/sounds/nn/diktat/fly.mp3'; //1
import audio2 from 'assets/sounds/nn/diktat/masse.mp3';//2
import audio3 from 'assets/sounds/nn/diktat/mjølk.mp3';//3
import audio4 from 'assets/sounds/nn/diktat/4-deg.mp3';//4
import audio5 from 'assets/sounds/nn/diktat/5-sau.mp3';//5
import audio6 from 'assets/sounds/nn/diktat/6-elefant.mp3';
import audio7 from 'assets/sounds/nn/diktat/7-gratt.mp3';
import audio8 from 'assets/sounds/nn/diktat/rekne.mp3';//8
import audio9 from 'assets/sounds/nn/diktat/9-stvlar.mp3';
import audio10 from 'assets/sounds/nn/diktat/korleis.mp3';//10
import audio11 from 'assets/sounds/nn/diktat/ekkelt.mp3';//11
import audio12 from 'assets/sounds/nn/diktat/ski.mp3';//12
import audio13 from 'assets/sounds/nn/diktat/13-kjole.mp3';
import audio14 from 'assets/sounds/nn/diktat/14-brannbil.mp3';
import audio15 from 'assets/sounds/nn/diktat/flokk.mp3';//15
import audio16 from 'assets/sounds/nn/diktat/senger.mp3';//16
import audio17 from 'assets/sounds/nn/diktat/kanskje.mp3';//17
import audio18 from 'assets/sounds/nn/diktat/sjokolade.mp3';//18
import audio19 from 'assets/sounds/nn/diktat/hjul.mp3';//19

import audio20 from 'assets/sounds/nn/diktat/rundt.mp3';//20


const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio9,
	10: audio10,
	11: audio11,
	12: audio12,
	13: audio13,
	14: audio14,
	15: audio15,
	16: audio16,
	17: audio17,
	18: audio18,
	19: audio19,
	20: audio20,

};

export default audioFiles;
